
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Card } from '../../../backend/backendapi';

@Component
export default class Labels extends Vue {
  @Prop({ required: true })
  card!: Card;
}

